import { useAppSelector } from 'hooks/reduxHooks';
import { get } from 'lodash-es';

interface ITeamsState {
  inTeams: boolean;
  inTeamsChannelTab: boolean;
  inTeamsPersonalTab: boolean;
  teamsContentUrl: string;
}

/**
 * Information about MS Teams context.
 *
 * @returns obj.inTeams - whether or not the app is being rendered in the MS Teams App
 * @returns obj.inTeamsChannelTab - app is being rendered in a teams channel tab
 * @returns obj.inTeamsPersonalTab - app is being rendered in a
 *  teams static personal tab.
 * @return the current teams content url.
 */
const useTeamsState = (): ITeamsState => {
  const teams = useAppSelector((state) => get(state, 'auth.teams', {}));
  const inTeams = get(teams, 'inTeams', false);
  const inTeamsChannelTab = get(teams, 'inTeamsChannelTab', false);
  const inTeamsPersonalTab = get(teams, 'inTeamsPersonalTab', false);
  const teamsContentUrl = get(teams, 'teamsContentUrl', '');
  return {
    inTeams,
    inTeamsChannelTab,
    inTeamsPersonalTab,
    teamsContentUrl,
  };
};

export default useTeamsState;
